
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderPromoGrid extends Serenity.EntityGrid<ECommOrderPromoRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommOrderPromo'; }
        protected getDialogType() { return ECommOrderPromoDialog; }
        protected getIdProperty() { return ECommOrderPromoRow.idProperty; }
        protected getInsertPermission() { return ECommOrderPromoRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderPromoRow.localTextPrefix; }
        protected getService() { return ECommOrderPromoService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}